module.exports = {
      id: "spike-usage",
      viewBox: "0 0 21 20",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#spike",
      toString: function () {
        return this.url;
      }
    }